import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/styles/NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  const [countdown, setCountdown] = useState(15);
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect after 15 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 15000);

    // Update countdown every second
    const countdownInterval = setInterval(() => {
      setCountdown((prevCount) => prevCount - 1);
    }, 1000);

    // Clean up timers
    return () => {
      clearTimeout(timer);
      clearInterval(countdownInterval);
    };
  }, [navigate]);

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-code">404</div>
        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-message">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-timer">
          <div className="timer-circle">
            <svg viewBox="0 0 100 100">
              <circle 
                className="timer-background" 
                cx="50" 
                cy="50" 
                r="45"
              />
              <circle 
                className="timer-progress" 
                cx="50" 
                cy="50" 
                r="45"
                style={{ 
                  strokeDashoffset: `${(1 - countdown / 15) * 283}` 
                }}
              />
            </svg>
            <div className="timer-count">{countdown}</div>
          </div>
          <p className="timer-text">Redirecting to homepage in {countdown} seconds</p>
        </div>
        <button 
          className="not-found-button"
          onClick={() => navigate('/')}
        >
          Go Home Now
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage; 